import { Tab } from "@headlessui/react";
import PropTypes from "prop-types";
import { SwiperSlide } from "swiper/react";

import { FaCheck } from "components/atoms/Icon/fa/FaCheck";
import Img from "components/atoms/Img";
import Link from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import PostItem from "components/molecules/PostItem";
import TabListNew from "components/molecules/TabListNew/index";
import Banner from "components/organisms/Banner";
import CardVirtualOffice from "components/organisms/CardVirtualOffice";
import Faqs from "components/organisms/Faqs";
import HowItWorks from "components/organisms/HowItWorks";
import PostSlider from "components/organisms/PostSlider";
import WhyChooseUs from "components/organisms/WhyChooseUs";

const VirtualOffice = ({ posts, data }) => {
  return (
    <>
      <section>
        <Banner
          minHeightBanner="banner-min-h-569"
          title="Virtual Office & Mailing Address In Vietnam"
          bgColor="bg-bbc-gradient-service"
          titleProps={{
            textColor: "bg-bbc-gradient-liner1 text-transparent bg-clip-text",
          }}
          breadcrumbs={data?.banner?.breadcrumbs}
          leftClassName="relative lg:mt-0 col-12 lg:col-7"
          rightClassName="col-12 lg:col-5"
          rightContent={
            <Img
              className="max-w-full object-cover object-center"
              src="/assets/images/offshore/virtual-office/banner-offshore-virtual_office.png"
              width={622}
              height={436}
              alt="virtual office service in Vietnam"
              priority={true}
              wrapper={{
                className: "bbc-banner-image-bottom-0",
              }}
            />
          }
        />
      </section>
      <section>
        <div className="container">
          <Title
            text="How does virtual office work for your company?"
            className="title-h2 mb-6 text-center capitalize text-bbc-brand-800 lg:text-left "
          />
          <div className="col-12">
            <div className="col-12 mb-10 text-base">
              <p className="mb-2">
                Looking for a virtual office that makes real impressions? Our
                burgeoning network of virtual workspaces can give your business
                a strong presence in key locations.
              </p>
              <p>
                Enjoy premium treatment in the forms of meeting room
                accessibility, mailing address acquisition, mail forwarding
              </p>
            </div>
            <div className="col-8 mx-auto">
              <div className="row">
                <div className="col-6 hidden lg:block">
                  <div className="rounded-3xl border-4 border-transparent bg-white px-4 py-6 hover:cursor-pointer hover:border-bbc-brand-500 hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]">
                    <div className="border-b border-bbc-neutral-500 pb-8">
                      <Title
                        as="h3"
                        text="Premium Package"
                        className="text-center text-3xl font-semibold leading-10 tracking-[0.25px] text-bbc-yellow-500"
                      />
                    </div>
                    <div className="border-b border-bbc-neutral-500 pt-8 pb-6">
                      <ul>
                        <li className="relative mb-2">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">
                            Prestigious mailing address
                          </span>
                        </li>
                        <li className="relative mb-2">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">
                            Mail handling service
                          </span>
                        </li>
                        <li className="relative">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">
                            Local telephone number /Phone handling
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="pt-6">
                      <p className="mb-2 font-semibold">Additional services</p>
                      <ul>
                        <li className="relative mb-2">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">Scan/fax</span>
                        </li>
                        <li className="relative mb-2">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">
                            Meeting room
                          </span>
                        </li>
                        <li className="relative mb-2">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">
                            Mail forwarding
                          </span>
                        </li>
                        <li className="relative">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">Others</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-6 hidden self-end lg:block">
                  <div className="rounded-3xl border-4 border-transparent bg-white px-4 py-6 hover:cursor-pointer hover:border-bbc-brand-500 hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]">
                    <div className="border-b border-bbc-neutral-500 pb-8">
                      <Title
                        as="h3"
                        text="Basic Package"
                        className="text-center text-3xl font-semibold leading-10 tracking-[0.25px] text-bbc-brand-500"
                      />
                    </div>
                    <div className="border-b border-bbc-neutral-500 pt-8 pb-6">
                      <ul>
                        <li className="relative mb-2">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">
                            Prestigious mailing address
                          </span>
                        </li>
                        <li className="relative">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">
                            Mail handling service
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="pt-6">
                      <p className="mb-2 font-semibold">Additional services</p>
                      <ul>
                        <li className="relative mb-2">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">Scan/fax</span>
                        </li>
                        <li className="relative mb-2">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">
                            Meeting room
                          </span>
                        </li>
                        <li className="relative mb-2">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">
                            Mail forwarding
                          </span>
                        </li>
                        <li className="relative">
                          <FaCheck
                            className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                            size={12}
                          />
                          <span className="inline-block pl-7">Others</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:hidden">
              <TabListNew
                data={["Premium", "Basic"]}
                tabListClass={{
                  othersClass: "mb-6",
                }}
              >
                <Tab.Panels>
                  <Tab.Panel
                    className="focus:outline-none focus:outline-0 focus:ring-0"
                    as="div"
                  >
                    <div className="rounded-3xl border-4 border-transparent bg-white px-4 py-6 hover:cursor-pointer hover:border-bbc-brand-500 hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]">
                      <div className="border-b border-bbc-neutral-500 pb-8">
                        <Title
                          as="h3"
                          text="Premium Package"
                          className="text-center text-3xl font-semibold leading-10 tracking-[0.25px] text-bbc-yellow-500"
                        />
                      </div>
                      <div className="border-b border-bbc-neutral-500 pt-8 pb-6">
                        <ul>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Prestigious mailing address
                            </span>
                          </li>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Mail handling service
                            </span>
                          </li>
                          <li className="relative">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Local telephone number /Phone handling
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="pt-6">
                        <p className="mb-2 font-semibold">
                          Additional services
                        </p>
                        <ul>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">Scan/fax</span>
                          </li>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Meeting room
                            </span>
                          </li>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Mail forwarding
                            </span>
                          </li>
                          <li className="relative">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">Others</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Tab.Panel>
                  <Tab.Panel
                    className="focus:outline-none focus:outline-0 focus:ring-0"
                    as="div"
                  >
                    <div className="rounded-3xl border-4 border-transparent bg-white px-4 py-6 hover:cursor-pointer hover:border-bbc-brand-500 hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]">
                      <div className="border-b border-bbc-neutral-500 pb-8">
                        <Title
                          as="h3"
                          text="Basic Package"
                          className="text-center text-3xl font-semibold leading-10 tracking-[0.25px] text-bbc-brand-500"
                        />
                      </div>
                      <div className="border-b border-bbc-neutral-500 pt-8 pb-6">
                        <ul>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Prestigious mailing address
                            </span>
                          </li>
                          <li className="relative">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Mail handling service
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="pt-6">
                        <p className="mb-2 font-semibold">
                          Additional services
                        </p>
                        <ul>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">Scan/fax</span>
                          </li>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Meeting room
                            </span>
                          </li>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Mail forwarding
                            </span>
                          </li>
                          <li className="relative">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">Others</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Tab.Panel>
                </Tab.Panels>
              </TabListNew>
            </div>
          </div>
        </div>
      </section>
      <WhyChooseUs
        title="Why choose BBCIncorp"
        sectionClassName="bg-bbc-gradient-2 py-10 lg:py-20 capitalize"
        data={data?.dataWhyChooseUs}
      />
      <HowItWorks data={data?.dataMakeItWork} className="mb-10 lg:mb-20">
        <Title className="text-center font-semibold capitalize lg:text-left">
          <span className="block text-3xl text-bbc-brand-800 lg:text-bbc-40px">
            Just 4 easy steps
          </span>
          <span className="mt-4 block text-3xl text-bbc-brand-700 lg:leading-[44px]">
            to make it work
          </span>
        </Title>
      </HowItWorks>
      <section>
        <Img
          src={"/assets/images/offshore/virtual-office/wave_top-virtual.svg"}
          width={1920}
          height={125}
          className="w-full"
          wrapper={{ className: " w-full  hidden lg:block" }}
          alt="Wave top"
        />
        <div className="lg:bg-bbc-package">
          <div className="container lg:pt-20 lg:pb-10">
            <Title
              text="Establish your worldwide presence"
              className="title-h2 mb-3 text-center capitalize text-bbc-brand-800 lg:mb-7"
            />
            <CardVirtualOffice data={data?.dataCountry} />
            <div className="mt-2 text-center lg:mt-6">
              <Link
                href="/contact-us"
                className="inline-block rounded-full bg-bbc-primary px-6 py-2 font-bold tracking-[0.5px] text-white transition-all duration-200 hover:bg-bbc-brand-600"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
        <Img
          src={"/assets/images/offshore/virtual-office/wave_bottom-virtual.svg"}
          width={1920}
          height={125}
          className="w-full"
          wrapper={{ className: " w-full hidden lg:block" }}
          alt="Wave bottom"
        />
      </section>
      <section>
        <div className="container">
          <div className="lg:col-10 lg:mx-auto">
            <Faqs
              description="Get to know more with frequently asked questions."
              data={data?.dataFaqs}
            />
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <PostSlider thetitle="Industry News & Insights">
            {posts.length > 0 &&
              posts.map((item, index) => (
                <SwiperSlide key={index}>
                  <PostItem post={item} />
                </SwiperSlide>
              ))}
          </PostSlider>
        </div>
      </section>
    </>
  );
};

export default VirtualOffice;

VirtualOffice.propTypes = {
  data: PropTypes.object,
  posts: PropTypes.array,
};

VirtualOffice.defaultProps = {
  data: {},
  posts: [],
};
